import store from "../../store/store";

export const componentKey = "INVENTORY_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setInventoryList: (state, action) => {
      state.inventoryList = action.payload;
    },
    setCloseInventoryDialog: (state, action) => {
      state.closeInventoryDialog = action.payload;
    },
    setCloseSendInventoryDialog: (state, action) => {
      state.closeSendInventoryDialog = action.payload;
    },
  },
  initialReducerState: {
    inventoryList: {},
    closeInventoryDialog: false,
    closeSendInventoryDialog: false,
  },
});

export const {
  setInventoryList,
  setCloseInventoryDialog,
  setCloseSendInventoryDialog,
} = actions;
